import type { PermissionType, RoleCreateType } from "@/api/user/types/worker"

interface ResolveActiveRolePermissionListOptions {
  activeRoleView: string
  allRoleView: string
  permissionList: string[]
  businessRoles: RoleCreateType[]
  allPermissions: PermissionType[]
}

export function hasUsableRolePermissionIds(businessRoles: RoleCreateType[], roleView: string) {
  const roleDetail = businessRoles.find((item) => {
    return `${item.merchantRole.merchantRoleId}` === roleView
  })
  return Array.isArray(roleDetail?.permissionIds)
}

export function resolveActiveRolePermissionList({
  activeRoleView,
  allRoleView,
  permissionList,
  businessRoles,
  allPermissions,
}: ResolveActiveRolePermissionListOptions) {
  if (activeRoleView === allRoleView) {
    return permissionList
  }
  const roleDetail = businessRoles.find((item) => {
    return `${item.merchantRole.merchantRoleId}` === activeRoleView
  })
  if (!roleDetail) {
    return []
  }
  const permissionIds = Array.isArray(roleDetail.permissionIds) ? roleDetail.permissionIds : []
  const permissionIdSet = new Set(permissionIds)

  return allPermissions
    .filter((permission) => {
      return permission.merchantPermissionId !== undefined && permissionIdSet.has(permission.merchantPermissionId)
    })
    .map((permission) => permission.permission)
}
